import { canonicalTag } from './canonicalTag';

/**
 * Whether a tag is one of the tags currently filtering, compared on the
 * canonical form rather than the spelling.
 *
 * One implementation because three places ask it and they have to agree: the
 * row chip decides whether to draw filled, the catalog checkbox decides whether
 * to draw ticked, and the toggle decides whether a click adds or removes. If
 * the chip says selected and the toggle says not, clicking a filled chip adds a
 * second filter for a tag that is already filtering.
 */
export const isTagSelected = (selectedTags: string[], tag: string): boolean =>
  selectedTags.some((selected) => canonicalTag(selected) === canonicalTag(tag));
